import React, { Component } from 'react';
import './Benefits.css';
import data from '../../data/Benefits.js';

import Layout from '../../components/Layout/Layout';
import Icon from '../../components/Icon/Icon';
import Intro from '../../components/Intro/Intro';

import Additional from './Additional/Additional';
import FSA from './FSA/FSA';
import Healthcare from './Healthcare/Healthcare';
import HealthcareFAQ from './HealthcareFAQ/HealthcareFAQ';
import Holidays from './Holidays/Holidays';
import PaidTimeOff from './PaidTimeOff/PaidTimeOff';
import Retirement from './Retirement/Retirement';
import TimeOff from './TimeOff/TimeOff';

class Benefits extends Component {
	render() {
		return (
			<Layout colors={ data.colors }>
				<div className="Benefits">
					<Intro>
						<Icon icon="benefits.intro" title="Perks For the People" />
						<div className="intro-title">
							<h1>Perks <span>For the</span> People</h1>
							<p>
								Questions about time off? Wondering if we have a health insurance deductible?
								<br />
								We have lots of great benefits – be sure you're making the most of them!
							</p>
						</div>
						
						<div className="contact">
							<div style={{ flex: '1' }} />
							<div className="name-title">
								<p>The HR Hero</p>
								<p>Karen Marrero</p>
							</div>
							<div className="message">
								<p className="message-mattermost">Karen Marrero</p>
								<p className="message-email">HR@idsi.com</p>
							</div>
							<div className="phone">
								<p className="phone-office">(703) 766-9631</p>
							</div>
						</div>
					</Intro>
					
					<Healthcare />
					<FSA />
					
					<HealthcareFAQ cards={ data.healthcareFAQ } />
					<PaidTimeOff slides={ data.paidTimeOff } />
					
					<div className="bg-gradient vertical">
						<TimeOff />
						<Holidays />
					</div>
					
					<Retirement />
					<Additional />
				</div>
			</Layout>
		);
	}
};

export default Benefits;



// WEBPACK FOOTER //
// ./src/pages/Benefits/Benefits.js